import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class InvoiceDetailService {
	showDetailSubject: Subject<boolean> = new Subject<boolean>();
	showDetail$: Observable<boolean> = this.showDetailSubject.asObservable();
}
